import { FormControl, AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class CustomValidators {
  static compareTo(compareTo: string): ValidatorFn {
    return (control: FormControl): { [key: string]: boolean } => {
      const form = control.parent;
      if (!form) {
        return null;
      }
      const compareToControl = form.controls[compareTo];
      if (!compareToControl) {
        return { compareTo: true };
      }
      if (control.value != compareToControl.value) {
        return { compareTo: true };
      }
      return null;
    };
  }

  static integer(control: AbstractControl): ValidationErrors | null {
    let result = Number(control.value);
    if (isNaN(result)) {
      return { integer: true };
    }
    result = Math.floor(result);
    if (typeof control.value == "number") {
      if (result !== control.value) {
        return { integer: true };
      }
    } else {
      if (String(result) !== control.value) {
        return { integer: true };
      }
    }
    return null;
  }
}
